import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { Box, Button, Typography } from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import { FunctionComponent, useState } from 'react';
import { useAppTranslate } from '../../../../core/hooks';
import { ChartSettings } from '../../../chart-settings/model';
import { MonitoredDeviceModel } from '../../model';
import { CpeStatisticsTableChartDialog } from '../CpeStatisticsTableChartDialog/CpeStatisticsTableChartDialog';
import { useTimeSeriesStatisticsHighchartsOptions } from '../../../timeseries-statistics/hooks/TimeSeriesStatistics.hook';
import { buildSeriesData, TimeSeriesMeasurement } from '../../../timeseries-statistics/model/TimeSeriesMeasurement.model';

interface Props {
  device: MonitoredDeviceModel;
  dataType: 'cpuUsage' | 'availability';
  data?: TimeSeriesMeasurement[];
  chartSettings: ChartSettings;
  customerId: number | null;
}

export const CpeStatisticsTableRowChart: FunctionComponent<Props> = ({ device, data, dataType, chartSettings, customerId }) => {
  const translate = useAppTranslate();
  const seriesName = `${translate('tableHeaders.' + dataType)}`;
  const seriesData = buildSeriesData(data || []);
  const [dialogOpen, setDialogOpen] = useState(false);
  const highchartOptions = useTimeSeriesStatisticsHighchartsOptions(chartSettings, '%', [{ seriesData, seriesName }]);

  return <Box role={'presentation'} sx={{ background: '#fff', borderRadius: '1rem', padding: 1 }}>
    <Box sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      justifyContent: 'space-between',
      alignItems: 'center',
      p: 3
    }}>
      <Typography>{ seriesName }</Typography>
      <Button
        variant='slim'
        size='small'
        endIcon={ <FullscreenIcon /> }
        onClick={ () => setDialogOpen(true) }
      >
        { translate('charts.fullview') }
      </Button>
    </Box>
    <HighchartsReact
      highcharts={Highcharts}
      options={highchartOptions}
    />
    { customerId !== null &&
    <CpeStatisticsTableChartDialog
      initialChartSettings={{ resolution: chartSettings.resolution, timespan: chartSettings.timespan }}
      dataType={dataType}
      open={dialogOpen}
      device={device}
      onClose={() => setDialogOpen(false)}
      customerId={customerId}
    /> }
  </Box>;
};